import React, { useRef } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import classNames from 'classnames'

import { StyledNavBarItem } from './styled'


const NavBarItem = ({ name, icon: Icon, Component, getLink, link, exact, action, className, style, disabled, withDropDown, active, onClick, hideInNav, noDisplayAsLink, ...props }) => {
	const navItemRef = useRef()
	const isRouter = typeof link !== 'undefined' || link === null
	const linkTo = getLink(link)
	const displayAsLink = isRouter && !disabled
	const isClickable = isRouter || typeof action === 'function'
	if(hideInNav) {
		return null
	}
	const handleClick = e => {
		if(onClick) {
			onClick(e)
		}
		if(disabled) {
			e.stopPropagation()
		} else if(typeof action === 'function') {
			action(e)
		}
	}
	let out = (
		<StyledNavBarItem
			ref={navItemRef}
			style={style}
			className={classNames(className, { active: active })}
			onClick={handleClick}
			isDisabled={disabled}
			isClickable={isClickable}
			withDropDown={withDropDown}
			{...displayAsLink && { as: noDisplayAsLink ? 'span' : 'a' }}
		>
			{Component ?
				<Component
					navItemRef={navItemRef}
					isDisabled={disabled}
					{...props}
				/> :
				<>{!!Icon && <Icon/>}{name}</>}
		</StyledNavBarItem>
	)

	if(displayAsLink) {
		out = (
			<LinkContainer exact={exact} to={linkTo}>
				{out}
			</LinkContainer>
		)
	}

	return out
}

NavBarItem.defaultProps = {
	getLink: (l) => `/${l}`,
	withDropDown: false
}

export default NavBarItem
